/**
 *  BubblesPowerup
 *
 *  Created by Legman on 31/05/2017.
 *
 */

import AOEPowerup from "./AOEPowerup";
import AudioParams from "../AudioParams";
import Bubbles from "./Bubbles";
import Common from "../Common";

/**
 * @class
 * @extends Powerup
 */
export default class BubblesPowerup extends AOEPowerup {
    /**
     * @param collector
     */
    constructor(collector) {
        super(collector);

        /**
         * @type {Audio}
         * @private
         */
        this._loopSFX = null;
    }

    destroy() {
        this._stopLoopSFX();

        super.destroy();
    }

    activate() {
        const activated = super.activate();
        if (activated) {
            this._aoe = new Bubbles(this._collector);
            this._aoe.powerupType = this.type;
            this._aoe.init();
            this._collector.view.addChild(this._aoe);

            this._aoe.start();

            delay(function() {
                this._collector.usingPowerup = false;
                this._aoe.stop();

                // gives time for particles to fade
                delay(function() {
                    this._aoe.parent.removeChild(this._aoe);
                    this._aoe.destroy();

                    this._stopLoopSFX();
                }, 1, this);
            }, this._aoe.duration, this);

            this._collector.view.visible && this._playLoopSFX();
        }
        return activated;
    }

    pause() {
        super.pause();
        this._stopLoopSFX();
    }

    resume() {
        super.resume();
        this._playLoopSFX();
    }

    /**
     * @private
     */
    _playLoopSFX() {
        this._stopLoopSFX();

        const params = new AudioParams();
        params.loop = true;
        this._loopSFX = Common.audio.playSound("sfx_powerup_bubbles_00", params);
    }

    /**
     * @private
     */
    _stopLoopSFX() {
        this._loopSFX && this._loopSFX.stop();
    }
}